<template>
  <div class="inner-page debugger">

    <AppHead title="Upload Debug" />

    <Button
      label="Retry Upload of One"
      color="green"
      size="large"
      icon="redo"
      @click="retryUpload"
      class="push-bottom"
      />

    <TableDocumentsDebug
      title="Document Library"
      desc="Files in the Document Library"
      noDocsMessage="There are no documents available"
      :files="docRoom"
      />

    <TableDocumentsDebug
      title="Enquiry Forms"
      desc="Files to be used as enquiry forms"
      noDocsMessage="There are no documents available"
      :files="enquiryForm"
      />

    <TableDocumentsDebug
      v-for="(project, index) in projects"
      :key="index"
      :title="`${project.id}`"
      :desc="project.description"
      noDocsMessage="There are no documents available"
      :files="project.uploads"
      />

  </div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import TableDocumentsDebug from "@/Components/TableDocumentsDebug"
import Button from "@/Components/Button"

export default {
  props: [
    'docRoom',
    'projects',
    'enquiryForm'
  ],
  components: {
    AppLayout,
    AppHead,
    TableDocumentsDebug,
    Button
  },
  mounted(){
    // console.log('files', this.projects)
  },
  methods: {
    retryUpload(){
      this.$inertia.post(`/admin/retry-upload`);
    }
  },
  layout: AppLayout
}

</script>

<style scoped lang="sass">

.debugger
  .push-bottom
    margin-bottom: 40px

</style>